<template>
  <div class="f-left">
    <div class="flex  align-center" style="overflow:hidden;">
      <el-input size="small" placeholder="请输入名称查询" clearable prefix-icon="el-icon-search" v-model="company"> </el-input>
      <el-button type="primary" @click="requieAll()" style="margin-left:20px" size="small">全部</el-button>
    </div>
    <div style="height:90%;width:100%;margin-top:.5rem">
      <ul class="com-warp">
        <li :style="idx == index ? 'background:#d0cfe9;opacity:1;font-weight:900' : ''" v-for="(item, index) in list" @click="select(item, index)" class="cursor" v-if="!company">
          {{ item.c_name }}
        </li>
        <li
          :style="idx == index ? 'background:#d0cfe9;opacity:1;font-weight:900' : ''"
          v-for="(item, index) in searchList"
          @click="select(item, index)"
          class="cursor"
          v-if="company"
        >
          {{ item.c_name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['url', 'isbim', 'companyNum', 'companyName'],
  data() {
    return {
      list: [],
      searchList: [],
      params: { page: 1 },
      company: '',
      idx: null,
      transfer: {},
    };
  },
  created() {
    this.getList();
  },

  mounted() {},
  methods: {
    checkCom() {
      let get_first_num = '';

      if (this.$local.get('company') && this.list.length) {
        console.log(4444);
        this.list.map((item) => {
          if (item.c_company_num === this.$local.get('company').c_company_num) {
            console.log('huoqu');
            // this.company = this.$local.get('company').c_name;
            // this.$emit('getFirst','');
          }
        });

        // get_first_num = this.$local.get('company').c_company_num;
      } else {
        console.log(555555);
        this.$local.save('company', this.list[0]);
        // get_first_num = this.list[0].c_company_num;
      }

      this.transfer = {
        c_company_num: this.companyNum,
        c_name: this.companyName,
      };

      if (this.companyNum) {
        get_first_num = this.companyNum;
        this.company = this.companyName || this.list.filter((it) => it.c_company_num == this.companyNum)?.c_name;
      }

      this.$emit('getFirst', '');
    },
    requieAll(){
      this.company=''
       let get_first_num = '';
        this.idx=null

       this.$emit('getFirst', get_first_num);
    },
    getList() {
      this.list = [];
      if (this.url) {
        this.$post('/trxf/main/xf/danwei/xfdanweixinxi/listdatanew', { c_belong_profession: 174 }).then((res) => {
          console.log(111);
          this.list = res.list;
          this.checkCom();
        });
      } else {
        this.$post('/devicemanage/selectconpanybyme').then((res) => {
          console.log(2222);

          this.list = res.data;
          this.checkCom();
          // this.$emit('getFirst',res.data[0].c_company_num)
        });
      }
    },
    select(val, index) {
      this.idx = index;
      this.$emit('select', val.c_company_num);
      this.$local.save('company', val);
    },
  },
  watch: {
    company(val) {
      if (val) {
        var arr = [];
        this.list.map((item, index) => {
          if (item.c_name.indexOf(val) !== -1) {
            arr.push(item);
          }
          this.searchList = arr;
        });
      } else {
        // alert('clear')
        this.idx=null
        this.$local.remove('company');
        this.$emit('getFirst','');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.com-warp {
  overflow: auto;
  height: 100%;
  li {
    font-size: 1rem;
    line-height: 2rem;
    color: #333;
    padding-left: 0.625rem;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 1.25rem;
  border-bottom: 0.0625rem solid #ddd;
  margin-bottom: 0.625rem;
}

.f-left {
  width: 16.25rem;
  border: 0.0625rem solid #ddd;
  border-radius: 0.625rem;
  padding: 0.625rem;
  display: flex;
  flex-direction: column;
  height: 39.5vw;
  margin-right: 1.875rem;
}
</style>
